/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';
import { PermissionName } from 'app/helpers/app-constants';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'merchant',
        title: 'Client Name',
        subtitle: 'ABN 12343546546',
        type: 'group',
        children: [
            {
                id: PermissionName.MerchantDashboard,
                title: 'Dashboard',
                type: 'basic',
                icon: 'mat_outline:dashboard',
                link: 'merchant/dashboard',
            },
            {
                id: PermissionName.MerchantSetting,
                title: 'Settings',
                type: 'basic',
                icon: 'mat_outline:settings',
                link: 'merchant/settings',
            },
            {
                id: PermissionName.MerchantPricing,
                title: 'Pricing',
                type: 'basic',
                icon: 'mat_outline:attach_money',
                link: 'merchant/pricing',
            },
            {
                id: PermissionName.MerchantPaymentPage,
                title: 'Payment',
                type: 'basic',
                icon: 'mat_outline:payment',
                link: 'merchant/payments',
            },
            {
                id: PermissionName.User,
                title: 'Users',
                type: 'basic',
                icon: 'mat_outline:people',
                link: 'merchant/users',
            },
            {
                id: PermissionName.Transaction,
                title: 'Transactions',
                type: 'basic',
                icon: 'mat_outline:receipt',
                link: 'merchant/transactions',
            },
        ],
    },
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id: 'example',
        title: 'Example',
        type: 'basic',
        icon: 'heroicons_outline:chart-pie',
        link: '/example',
    },
];
